export default container => {
  const progressBars = container.querySelectorAll('[data-scroll-progress]')

  if (progressBars) {
    window.addEventListener('scroll', () => {
      const documentScrollHeight = document.body.scrollHeight
      const windowHeight = window.innerHeight
      const scrollHeight = documentScrollHeight - windowHeight
      const progressHeight = window.pageYOffset / scrollHeight

      progressBars.forEach(progressBar => {
        progressBar.style.transform = `scale(${progressHeight}, 1)`
      })
    })
  }
}
